import React, { useEffect, useState }  from 'react'
import ReactPlayer from 'react-player/lazy'
import { Carousel } from 'react-bootstrap'
import { mediaDeviceSizes } from '../../../../constants/mediaQueries'
import { getSize } from '../../../../utils'
import { IntroSectionStyle } from '../styles'
import { CheckoutButton } from '../../../../styles'

export const RetIntro = () => {
    let [device, setDevice] = useState(null)

    useEffect(() => {
        setDevice(getSize(window.innerWidth))
    }, [])

    const onScrollTo = (e) => {
        e.preventDefault() 
        document.getElementById('nextSection').scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
        })
    }

    return (
        <IntroSectionStyle className='up-win-trial ret'>
            <div className='container'>
                <div className='content long-txt'>
                    <h1>COME BACK TO PRO! <span className='price'>SAVE 40%</span> PLUS 
                        <br />GET 2 TRADE DOCTOR SESSIONS</h1>
                    <p>The cure to all trading troubles, patience PLUS training! Lock PRO in for less than <span className='grn-txt'>$5 per day</span> and get access to personal support sessions from our Trade Doctor. You'll be ready for the next crypto boom in no time!</p>
                </div>
                <div className='video-wrapper'>
                    <ReactPlayer 
                        url={'https://vimeo.com/758682602/3843616155'}
                        controls={true} 
                        width='100%' 
                        volume={0} />
                </div>

                <div className='checkout-btn'>
                    <CheckoutButton 
                        position="centered"
                        type="button" 
                        onClick={(e) => onScrollTo(e)}>
                        <span>Learn More</span>
                    </CheckoutButton>
                </div>

                <div className='trust-pilot-rating'>
                    <span className='score'>4.6 Trustscore on</span>
                    <span className='tp-logo'>
                        <img src='/images/offers/trustpilot-icon.svg' className='icon-logo' alt='ProfitFarmers - TrustPilot Icon Logo' />
                        <img src='/images/offers/trustpilot-text-light.svg' className='text-logo' alt="ProfitFarmers - TrustPilot Text Logo" />
                        <img src='/images/offers/trustpilot-rating-stars.png' className='rating-stars' alt='ProfitFarmers - TrustPilot rating score' />
                    </span>
                </div>

                <div className='featured-logo-container'>
                    <span>As Featured On</span>
                    <div className='featured-logos'>
                        { (device === mediaDeviceSizes.xs) &&
                            <Carousel controls={false}>
                                <Carousel.Item interval={1500}>
                                    <div className='logo-carousel'>
                                        <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                        <img src='/images/trial-offer/cryptonewsflash-logo.svg' alt='TrustPilot Score' />
                                    </div>
                                </Carousel.Item>
                                <Carousel.Item interval={1500}>
                                    <div className='logo-carousel'>
                                        <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                        <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                    </div>
                                </Carousel.Item>
                                <Carousel.Item interval={1500}>
                                    <div className='logo-carousel'>
                                        <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                        <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                    </div>
                                </Carousel.Item>
                                <Carousel.Item interval={1500}>
                                    <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                                </Carousel.Item>
                            </Carousel>
                        }

                        { !(device === mediaDeviceSizes.xs) &&
                            <><div className='logo-col'>
                                <img src='/images/trial-offer/ambcrypto-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/cryptonewsflash-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/btcmanager-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/crypto-insider-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/btc-echo-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/coingape-logo.svg' alt='TrustPilot Score' />
                            </div>
                            <div className='logo-col'>
                                <img src='/images/trial-offer/kointimes-logo.png' alt='TrustPilot Score' />
                            </div></>
                        }    
                    </div>
                </div>
            </div>
        </IntroSectionStyle>
    )
}